/*

 UA Shared UI Elements

*/

import GridTwo from './grids/grid_two.js';
import UaFauxDialog from './faux_dialog/faux_dialog.js';
import UaFormItem from './form_item/form_item.js';
import UaImageToggle from '../../shared_ui/custom_elements/image_toggle/image_toggle.js';
import UaJumpButton from './jump_button/jump_button.js';
import UaNeedHelpBox from './need_help_box/need_help_box.js';
import UaSelectField from '../../shared_ui/custom_elements/select_field/select_field.js';
import UaValidationMessage from './form_item/validation_message.js';
import UaCardBlogPost from './card_blog_post/card_blog_post.js';
import UaCardProgram from './card_program/card_program.js';
import MusicCardV3 from './card/card.js';
import UaSearchField from './search_field/search_field.js';
import UaMastheadMenu from './masthead_menu/masthead_menu.js';

customElements.define('l-grid-two', GridTwo);
customElements.define('ua-card-blog-post', UaCardBlogPost);
customElements.define('ua-card-program', UaCardProgram);
customElements.define('ua-faux-dialog', UaFauxDialog);
customElements.define('ua-form-item', UaFormItem);
customElements.define('ua-image-toggle', UaImageToggle);
customElements.define('ua-jump-button', UaJumpButton);
customElements.define('ua-need-help-box', UaNeedHelpBox);
customElements.define('ua-select-field', UaSelectField);
customElements.define('ua-validation-message', UaValidationMessage);
customElements.define('music-card-v3', MusicCardV3);
customElements.define('ua-search-field', UaSearchField);
customElements.define('ua-masthead-menu', UaMastheadMenu);
